import { render } from "./CreateWhatsappConfig.vue?vue&type=template&id=23dd68f7"
import script from "./CreateWhatsappConfig.vue?vue&type=script&lang=js"
export * from "./CreateWhatsappConfig.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__